import { HolderService } from "@/generated/services/HolderService";
import { useQuery, useMutation } from "@tanstack/react-query";

export function useFetchHolders(memberId: number) {
  return useQuery({
    queryKey: ["holders", memberId],
    enabled: !!memberId,
    queryFn: async () => {
      if (!memberId) throw new Error("Invalid member ID");
      const response = await HolderService.getMembersHolders(memberId);
      return response;
    },
  });
}

export function useFetchHoldersMutation() {
  return useMutation({
    mutationFn: async (memberId: number) => {
      if (!memberId) throw new Error("Invalid member ID");
      const response = await HolderService.getMembersHolders(memberId);
      return response;
    },
  });
}
